<template>
  <div>
    <el-card class="box-card boxcard">
      <div slot="header" class="clearfix">
        <b><i class="el-icon-s-unfold"></i>发票录入</b>
      </div>
      <div class='contijiao wkbmf loaded' v-if="tableRadio.iinport==1">
        <div class='stamp'> </div>
      </div>
      <div style="width:100%; height:55px">
        <div class="pull-right">
          <el-button type="success" plain size="medium" @click="myorder">我的发票单</el-button>
          <el-button type="primary" plain size="medium" @click="svevivade('1')"
            :disabled="tableRadio.iinport==1">保存</el-button>
          <el-button type="primary" size="medium" @click="svevivade('2')" :disabled="tableRadio.iinport==1"
            v-loading.fullscreen.lock="fullscreenLoading">提交</el-button>
          <el-button type="danger" plain size="medium" @click="UnSubmitInvoice()">撤销提交</el-button>
          <el-button type="warning" plain size="medium" @click="printpage()">打印</el-button>
          <el-button type="danger" size="medium" @click="DeleteSHInfo" :disabled="tableRadio.iinport==1">删除</el-button>
          <el-button type="info" plain size="medium" @click="returnpage">返回</el-button>
        </div>
      </div>
      <div style="width:100%">
        <el-form :inline="true" :model="tableRadio" class="demo-form-inline itemwidth" label-width="110px">
          <!-- <el-form-item label="发票号" :disabled="tableRadio.iinport==1">
            <el-input v-model="tableRadio.cfpcode" placeholder="发票号"></el-input>
          </el-form-item> -->
          <el-form-item label="公司名称">
            <el-select v-model="tableRadio.cpasturecode" filterable  clearable placeholder="请选择" :disabled="tableRadio.iinport==1"
              @change="GetBusinessOperList('1')">
              <el-option v-for="item in selectlist" :key="item.ccorpcode" :label="item.ccorpname"
                :value="item.ccorpcode"></el-option>
            </el-select>
          </el-form-item>
          <!-- <el-form-item label="供应商名称">
            <el-input v-model="tableRadio.cvenname" placeholder="供应商名称" :disabled="tableRadio.iinport==1"></el-input>
          </el-form-item> -->
          <el-form-item label="牧场人员">
            <el-select v-model="copcode" clearable placeholder="请选择" :disabled="tableRadio.iinport==1"
              @change="GetBusinessOperList('2')">
              <el-option v-for="item in renyuanlist" :key="item.copcode" :label="item.copname"
                :value="item.copcode"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="发票日期">
            <!-- 当前日期 -->
            <el-date-picker type="date" v-model="nowdate" value-format="yyyy-MM-dd" placeholder="发票日期"
              :disabled="tableRadio.iinport==1"></el-date-picker>
          </el-form-item>
          <!-- <el-form-item label="币种">
            <el-select v-model="tableRadio.cexch_name" clearable placeholder="请选择" :disabled="tableRadio.iinport==1">
              <el-option label="人民币" value="人民币"></el-option>
              <el-option label="美币" value="美币"></el-option>
            </el-select>
          </el-form-item> -->
          <!-- <el-form-item label="汇率">
            <el-input v-model="tableRadio.iexch_rate" placeholder="汇率" :disabled="tableRadio.iinport==1"></el-input>
          </el-form-item> -->
          <!-- <el-form-item label="不含税金额">
            <el-input v-model="tableRadio.itaxmoney" placeholder="不含税金额" :disabled="tableRadio.iinport==1"></el-input>
          </el-form-item>
          <el-form-item label="含税金额">
            <el-input v-model="tableRadio.itotalmoney" placeholder="含税金额" :disabled="tableRadio.iinport==1"></el-input>
          </el-form-item> -->
          <!-- <el-form-item label="税率(%)">
            <el-select v-model="tableRadio.cmwskz" filterable placeholder="请选择" :disabled="tableRadio.iinport==1">
              <el-option v-for="item in selectitax" :key="item.value" :label="item.ctaxname" :value="item.ctaxcode">
              </el-option>
            </el-select>
          </el-form-item> -->
          <el-form-item label="付款条件">
            <el-input v-model="tableRadio.cztermname" placeholder="付款条件"></el-input>
          </el-form-item>
          <el-form-item label="发票类型">
            <el-select v-model="tableRadio.creceipttype" filterable placeholder="发票类型"
              :disabled="tableRadio.iinport==1">
              <el-option label="蓝字发票" value="蓝字发票"></el-option>
              <el-option label="红字发票" value="红字发票"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="发票附件类型">
            <el-select v-model="tableRadio.cvouchtype" filterable placeholder="发票类型" :disabled="tableRadio.iinport==1">
              <el-option label="纸质发票" value="纸质发票"></el-option>
              <el-option label="电子发票" value="电子发票"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="其他综合扣款">
            <el-input v-model="tableRadio.izlkk" placeholder="其他综合扣款" :disabled="tableRadio.iinport==1"
              readonly></el-input>
          </el-form-item>
          <el-form-item label="备注" class="cremark">
            <el-input v-model="tableRadio.cpbvmemo" placeholder="备注"></el-input>
          </el-form-item>
          <!-- 
           <el-form-item label="提交人员">
            <el-input v-model="tableRadio.cinportop" placeholder="提交人员"></el-input>
          </el-form-item>
          <el-form-item label="提交日期">
            <el-date-picker type="date" v-model="tableRadio.dinportdate" value-format="yyyy-MM-dd" placeholder="提交日期"></el-date-picker>
          </el-form-item> -->
          <!-- <el-form-item label="SAP单号">
            <el-input v-model="tableRadio.csapcode" placeholder="SAP单号"></el-input>
          </el-form-item> -->
        </el-form>
      </div>
    </el-card>
    <el-card class="box-card boxcard">
      <div slot="header" class="clearfix">
        <b><i class="el-icon-s-unfold"></i>开票详情</b>
      </div>
      <div style="width:100%; height:55px">
        <div class="pull-right">
          <el-button type="success" plain size="medium" @click="handleExport('export-0002')">输出开票详情</el-button>
          <el-button type="success" plain size="medium" @click="handleExport('export-0003')">输出开票汇总</el-button>
          <el-button type="primary" plain size="medium" @click="queryInvoiceSummary">开票汇总</el-button>
        </div>
      </div>
      <div class="text item text-center">
        <el-table :data="tableorder" style="width: 100%" :summary-method="getSummaries" class="tableinput tablecenter"
          show-summary max-height="420" border :header-cell-style="{ background: '#eef1f6'}"
          :cell-style="{ padding: '7px 0'}">
          <el-table-column prop="cpocode" label="订单号" width="110"></el-table-column>
          <el-table-column prop="cincode" label="入库单号" min-width="110"></el-table-column>
          <el-table-column prop="cinvcode" label="物料编码" width="110"></el-table-column>
          <el-table-column prop="cinvname" label="物料名称" min-width="150"></el-table-column>
          <el-table-column prop="cinvunit" label="计量单位" width="90"></el-table-column>
          <el-table-column prop="iquantity" label="开票数量" width="90"></el-table-column>
          <el-table-column prop="ctaxationcode" label="税收分类" width="140"></el-table-column>
          <el-table-column prop="ctaxationname" label="厂商物料描述" width="140"></el-table-column>
          <el-table-column prop="iprice" label="单价" width="90"></el-table-column>
          <el-table-column prop="imoney" label="送货金额" width="90"></el-table-column>
          <el-table-column prop="ijfmoney" label="奖罚金额" width="90"></el-table-column>
          <el-table-column prop="irate" label="税率" min-width="60"></el-table-column>
          <el-table-column prop="iratemoney" label="税额" width="115">
            <template slot-scope="scope">
              <span v-if="tableRadio.iinport==1|| scope.row.irate==0 ">{{scope.row.iratemoney}}</span>
              <el-input size="small" v-else v-model="scope.row.iratemoney" oninput="value=value.replace(/[^\d.]/g,'')"
                placeholder="税额" @blur="getitax(scope.$index)" class="inputmin" style="width:90px"></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="inomoney" label="不含税金额" width="115">
            <template slot-scope="scope">
              <span v-if="tableRadio.iinport==1 ">{{scope.row.inomoney}}</span>
              <el-input size="small" v-else v-model="scope.row.inomoney" oninput="value=value.replace(/[^\d.]/g,'')"
                placeholder="不含税金额" @blur="getinomoney(scope.$index)" class="inputmin" style="width:90px"></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="iallmoney" label="含税金额" width="100"></el-table-column>
          <el-table-column prop="izlkk" label="其他综合扣款" width="100"></el-table-column>
          <el-table-column prop="ikpmoney" label="开票金额" width="100"></el-table-column>
          <el-table-column prop="drkdate" label="入库日期" width="100">
            <template slot-scope="scope">
              <font v-if="scope.row.drkdate!=''&&scope.row.drkdate">{{scope.row.drkdate.substring(0,10)}}</font>
              <font v-else>{{scope.row.drkdate}}</font>
            </template>
          </el-table-column>
          <!-- <el-table-column prop="cdepcode" label="业务部门" width="100"></el-table-column> -->

          <el-table-column prop="cremark" label="备注" width="100"></el-table-column>

          <!-- <el-table-column prop="cinvstd" label="规格" width="60"></el-table-column>
          <el-table-column prop="cpersoncode" label="业务员" width="110"></el-table-column>
          <el-table-column prop="cpinpai" label="品牌" min-width="200"></el-table-column>
          <el-table-column prop="cyear" label="会计年度" min-width="90"></el-table-column>
          <el-table-column prop="dindate" label="入库日期" width="90"></el-table-column>
          <el-table-column prop="irateprice" label="本币含税单价" width="110"></el-table-column>
          <el-table-column prop="irkqty" label="入库数量" min-width="90"></el-table-column>

          <el-table-column label="调整单价" min-width="120">
            <template scope="scope">
              <el-input size="small" v-model="scope.row.itzprice" placeholder="调整单价" style="width:90px"></el-input>
            </template>
          </el-table-column> -->

          <el-table-column label="操作" width="120" fixed="right" v-if="tableRadio.iinport!=1">
            <template slot-scope="scope">
              <el-button size="mini" type="danger" @click="del(scope.row, scope.$index)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="text item text-center" id="export" style="display:none">
        <h3 class="text-center">发票单打印</h3>
        <table cellpadding="0" cellspacing="0" class="tableshd">
          <thead>
            <tr>
              <th>订单号</th>
              <th>入库单号</th>
              <!-- <th>业务部门</th> -->
              <th>物料编码</th>
              <th>物料名称</th>
              <th>计量单位</th>
              <th>开票数量</th>
              <th>单价</th>
              <th>送货金额</th>
              <th>奖罚金额</th>
              <th>税率</th>
              <th>税额</th>
              <th>含税金额</th>
              <th>备注</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(row,i) in tableorder" :key="i">
              <td>{{row.cpocode}} </td>
              <td>{{row.cincode}} </td>
              <!-- <td>{{row.cdepcode}} </td> -->
              <td>{{row.cinvcode}} </td>
              <td>{{row.cinvname}} </td>
              <td>{{row.cinvunit}} </td>
              <td>{{row.iquantity}} </td>
              <td>{{row.iprice}} </td>
              <td>{{row.imoney}} </td>
              <td>{{row.ijfmoney}} </td>
              <td>{{row.irate}} </td>
              <td>{{row.iratemoney}} </td>
              <td>{{row.iallmoney}} </td>
              <td>{{row.cremark}} </td>
            </tr>
          </tbody>
        </table>

      </div>
    </el-card>

    <el-card class="box-card boxcard">
      <div slot="header" class="clearfix">
        <b><i class="el-icon-s-unfold"></i>发票拍照识别</b>
        <font style="color:#ff0000;margin-left:15px;font-size:12px">发票详情在提交后，系统会进行校验，自动显示发票信息。</font>
      </div>
      <div style="width:100%; height:55px">
        <div class="pull-right">
          <el-button type="primary" plain size="medium" @click="queryinvoice">发票单详情</el-button>
          <el-button type="success" plain size="medium" @click="myinvoice"
            :disabled="tableRadio.iinport==1">上传发票单</el-button>
          <el-button type="warning" plain size="medium" @click="GetHTFileUrl">预览</el-button>
        </div>
      </div>
      <div class="text item text-center">

        <el-table :data="tableinvioce" style="width: 100%" max-height="420" border :cell-style="{ padding: '7px 0' }"
          @current-change="clickChange">
          <el-table-column label="选择" width="55">
            <template slot-scope="scope">
              <el-radio v-model="tablerow" :label="scope.row">
                <i>
                </i>
              </el-radio>
            </template>
          </el-table-column>
          <el-table-column prop="cbillname" label="发票名称" min-width="160"></el-table-column>
          <el-table-column prop="cannulname" label="厂商名称" min-width="170">
            <template slot-scope="scope">
              <span v-if="tableRadio.iinport==1">{{scope.row.cannulname}}</span>
              <el-input size="small" v-else v-model="scope.row.cannulname" placeholder="厂商名称" class="inputmin"
                style="width:160px"></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="cannulid" label="厂商识别号" min-width="150">
            <template slot-scope="scope">
              <span v-if="tableRadio.iinport==1">{{scope.row.cannulid}}</span>
              <el-input size="small" v-else v-model="scope.row.cannulid" placeholder="厂商识别号" class="inputmin"
                style="width:140px"></el-input>
            </template>
          </el-table-column>

          <el-table-column prop="cbillcode" label="发票号" min-width="150">
            <template slot-scope="scope">
              <span v-if="tableRadio.iinport==1">{{scope.row.cbillcode}}</span>
              <el-input size="small" v-else v-model="scope.row.cbillcode" placeholder="发票号" class="inputmin"
                style="width:140px"></el-input>
            </template>
          </el-table-column>
          <!-- <el-table-column prop="cinvoicecode" label="发票代码" min-width="110"></el-table-column> -->
          <el-table-column prop="cinvoicecode" label="发票代码" min-width="150">
            <template slot-scope="scope">
              <span v-if="tableRadio.iinport==1">{{scope.row.cinvoicecode}}</span>
              <el-input size="small" v-else v-model="scope.row.cinvoicecode" placeholder="发票代码" class="inputmin"
                style="width:140px"></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="dbilldate" label="开票日期" min-width="150">
            <template slot-scope="scope">
              <span v-if="tableRadio.iinport==1">
                <font v-if="scope.row.dbilldate!=''&&scope.row.dbilldate">{{scope.row.dbilldate.substring(0,10)}}</font>
                <font v-else>{{scope.row.dbilldate}}</font>
              </span>

              <el-date-picker size="small" v-else v-model="scope.row.dbilldate" type="date" placeholder="开票日期"
                style="width:140px" format="yyyy-MM-dd" value-format="yyyy-MM-dd">
              </el-date-picker>
            </template>
          </el-table-column>
          <el-table-column prop="cbuyername" label="购买方名称" min-width="170">
            <template slot-scope="scope">
              <span v-if="tableRadio.iinport==1">{{scope.row.cbuyername}}</span>
              <el-input size="small" v-else v-model="scope.row.cbuyername" placeholder="购买方名称" class="inputmin"
                style="width:160px"></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="cbuyerid" label="购买方识别号" min-width="150">
            <template slot-scope="scope">
              <span v-if="tableRadio.iinport==1">{{scope.row.cbuyerid}}</span>
              <el-input size="small" v-else v-model="scope.row.cbuyerid" placeholder="购买方识别号" class="inputmin"
                style="width:140px"></el-input>
            </template>
          </el-table-column>
          <!-- <el-table-column prop="dbilldate" label="开票日期" min-width="110">
            <template slot-scope="scope">
              <font v-if="scope.row.dbilldate!=''&&scope.row.dbilldate">{{scope.row.dbilldate.substring(0,10)}}</font>
              <font v-else>{{scope.row.dbilldate}}</font>
            </template>
          </el-table-column> -->
          <!-- <el-table-column prop="ibillamount" label="发票金额" min-width="110"></el-table-column> -->
          <el-table-column prop="ibillamount" label="发票金额" min-width="150">
            <template slot-scope="scope">
              <span v-if="tableRadio.iinport==1">{{scope.row.ibillamount}}</span>
              <el-input size="small" oninput="value=value.replace(/[^\-?\d.]/g,'')" v-else
                v-model="scope.row.ibillamount" placeholder="发票金额" class="inputmin" style="width:140px"></el-input>
            </template>
          </el-table-column>
          <!-- <el-table-column prop="iprice_file" label="单价" min-width="110"></el-table-column>
          <el-table-column prop="itaxrate" label="税率" min-width="110"></el-table-column> -->
          <el-table-column prop="itax" label="税额" min-width="150">
            <template slot-scope="scope">
              <span v-if="tableRadio.iinport==1">{{scope.row.itax}}</span>
              <el-input size="small" oninput="value=value.replace(/[^\d.]/g,'')" v-else v-model="scope.row.itax"
                placeholder="税额" class="inputmin" style="width:140px"></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="inotax" label="不含税金额" min-width="150">
            <template slot-scope="scope">
              <!-- {{tableRadio.iinport}} -->
              <span v-if="tableRadio.iinport==1">{{scope.row.inotax}}</span>
              <el-input size="small" oninput="value=value.replace(/[^\-?\d.]/g,'')" v-else v-model="scope.row.inotax"
                placeholder="不含税金额" class="inputmin" style="width:140px"></el-input>
            </template>
          </el-table-column>
          <!-- <el-table-column prop="cisupload" label="发票上传"></el-table-column> -->
          <!-- <el-table-column prop="cbillurl" label="上传路径" width="100"></el-table-column> -->
          <el-table-column label="操作" width="200" fixed="right" v-if="tableRadio.iinport!=1">
            <template slot-scope="scope">
              <el-button size="mini" type="danger" @click="delinvioce(scope.row, scope.$index)">删除</el-button>
              <el-button size="mini" type="primary" @click="FeeControl(scope.row, scope.$index)">手工上传</el-button>
            </template>
          </el-table-column>
        </el-table>

      </div>
    </el-card>
    <el-card class="box-card boxcard">
      <div slot="header" class="clearfix">
        <b><i class="el-icon-s-unfold"></i>电子发票pdf上传</b>
      </div>
      <!-- <div style="width:100%; height:55px" v-if="tableRadio.iinport!=1 ">
        <div class="pull-right">
          <el-upload style="display:inline-block;margin-right:10px;" action="#" ref="uploadFail" :show-file-list="false"
            :before-upload="brforeUploadreImportFail" :auto-upload="false" :on-change="handleChangeFail"
            :file-list="fileListFail" accept=".pdf,.PDF">
            <el-button type="success" plain size="medium">上传电子发票(pdf)</el-button>
          </el-upload>
        </div>
      </div> -->
      <div class="text item text-center">

        <el-table :data="tablePDF" style="width: 100%" max-height="420" border :cell-style="{ padding: '7px 0' }">

          <el-table-column prop="cpdfname" label="PDF名称" min-width="110"></el-table-column>
          <el-table-column prop="cpdfurl" label="PDF路径" min-width="110"></el-table-column>

          <el-table-column label="操作" width="150" fixed="right" v-if="tableRadio.iinport!=1">
            <template slot-scope="scope">
              <el-button size="mini" type="warning" plain @click="getyulan(scope.row)">预览</el-button>
              <el-button size="mini" type="danger" @click="delinfile(scope.row, scope.$index)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>

      </div>
    </el-card>
    <el-dialog :visible.sync="dialogFormVisible" :append-to-body="true" customClass="assoformwarp">
      <el-form ref="assoruleForm" :model="qualiform" :inline="true" label-width="80px">
        <el-form-item label="订单号:" prop="dfilestarttime">
          <el-input v-model="qualiform.cordercode" placeholder="订单号"></el-input>
        </el-form-item>
        <el-form-item label="物料描述:" prop="dfilestarttime">
          <el-input v-model="qualiform.cinvname" placeholder="物料描述"></el-input>
        </el-form-item>
        <!-- <el-form-item label="日期:" prop="dfilestarttime">
          <el-date-picker v-model="timeval" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd" style="width:240px"></el-date-picker>
        </el-form-item> -->
        <el-form-item prop="dfilestarttime" label-width="0">
          <!-- <el-button type="primary" @click="GetRKList()">查询</el-button> -->
          <Debounce :time='300' :isDebounce="1">
            <el-button type="primary" @click.native="GetRKList()" size="medium">查询</el-button>
          </Debounce>
        </el-form-item>
      </el-form>
      <el-table :data="orderlist" style="width: 100%" max-height="420" border :cell-style="{ padding: '7px 0' }"
        tooltip-effect="dark" @selection-change="handleSelectionChange" @row-click="handleRowClick" ref="multipleTable">
        <el-table-column type="selection" width="40"></el-table-column>
        <!-- <el-table-column prop="cyear" label="会计年度" width="80"></el-table-column> -->
        <!-- <el-table-column prop="ccorpcode" label="工厂编号" min-width="90"></el-table-column> -->
        <!-- <el-table-column prop="ccorpname" label="公司名称" width="160"></el-table-column> -->
        <!-- <el-table-column prop="cvenname" label="厂商" width="200"></el-table-column> -->
        <el-table-column prop="crkcode" label="入库单号" min-width="120"></el-table-column>

        <!-- <el-table-column prop="crkhang" label="入库单行" width="120"></el-table-column> -->
        <el-table-column prop="cordercode" label="订单号" width="110"></el-table-column>
        <!-- <el-table-column prop="corderhang" label="订单行" min-width="110"></el-table-column> -->
        <el-table-column prop="drkdate" label="入库日期" width="100">
          <template slot-scope="scope">
            <font v-if="scope.row.drkdate!=''&&scope.row.drkdate">{{scope.row.drkdate.substring(0,10)}}</font>
            <font v-else>{{scope.row.drkdate}}</font>z
          </template>
        </el-table-column>
        <!-- <el-table-column prop="date" label="日期" width="90"></el-table-column> -->

        <!-- <el-table-column prop="cvencode" label="厂商编码" min-width="90"></el-table-column> -->
        <el-table-column prop="csapinvcode" label="SAP编码" width="100"></el-table-column>
        <el-table-column prop="cinvname" label="物料描述" width="200" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="ctaxationcode" label="税收分类" width="100"></el-table-column>
        <el-table-column prop="ctaxationname" label="厂商物料描述" width="100"></el-table-column>
        <el-table-column prop="cinvmodel" label="规格" width="60"></el-table-column>
        <el-table-column prop="cunit" label="基本计量单位" min-width="105"></el-table-column>
        <!-- <el-table-column prop="crkunit" label="入库单位" min-width="100"></el-table-column> -->
        <el-table-column prop="inumber" label="待开票数量" width="110"></el-table-column>
        <el-table-column prop="ifpnumber" label="已开票数量" width="110"></el-table-column>
        <el-table-column prop="iprice" label="单价" width="90"></el-table-column>
        <el-table-column prop="itaxe" label="税率" width="60"></el-table-column>
        <!-- <el-table-column prop="inotaxeprice" label="不含税单价" min-width="110"></el-table-column> -->
        <el-table-column prop="imoney" label="发货金额" min-width="100"></el-table-column>
        <el-table-column prop="ijfmoney" label="奖罚金额" width="100"></el-table-column>
        <el-table-column prop="itoltalmoney" label="开票含税金额" width="100"></el-table-column>
        <el-table-column prop="izlkk" label="其他综合扣款" width="100"></el-table-column>
        <el-table-column prop="ikpmoney" label="开票金额" width="100"></el-table-column>

        <!-- <el-table-column prop="ipriceunit" label="单价单位" min-width="80"></el-table-column> -->

      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closesad()">取 消</el-button>
        <el-button type="success" @click="confirm()">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="invoiceVisible" :append-to-body="true" customClass="inviocewarp">
      <el-form :model="invioceform" ref="invioceform" :rules="inviocerules" label-width="100px" v-loading="loading">
        <el-row>

          <el-col :span="24">
            <el-form-item prop="cbillurl" label="发票单:">
              <el-upload style="display:inline-block;margin:0" action="#" ref="uploadref" :show-file-list="false"
                :before-upload="brforeUploadreFail" :auto-upload="false" :on-change="handleChange"
                :file-list="fileListFail" :accept="typeaccept">
                <el-button type="success" plain size="medium">上传发票单({{typeaccept}})</el-button>
              </el-upload>
              <br>{{invioceform.cbillname}}
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item>
              <font style="color:#ff0000">请每张发票进行上传,确保发票拍照清晰度,确保提交时能够满足图片校验。</font>
            </el-form-item>
          </el-col>

        </el-row>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="closesad()">取 消</el-button>
        <el-button type="success" @click="inviocecofrim('invioceform')" :loading="loadingSC">确 定</el-button>
      </div>
    </el-dialog>
    <operprint v-if="prinpageif" :prinpageif="prinpageif" :prinpagesrc="prinpagesrc" @printclose="printclose" />
    <el-dialog :visible.sync="dialogqueryVisible" :append-to-body="true" customClass="assoformwarp">
      <el-table :data="querytableorder" style="width: 100%" class="tableinput tablecenter" max-height="420" border
        :header-cell-style="{ background: '#eef1f6'}" :cell-style="{ padding: '7px 0'}">
        <el-table-column prop="cfpcodexq" label="发票号" min-width="110"></el-table-column>
        <el-table-column prop="ctaxationcode" label="税收分类" width="140"></el-table-column>
        <el-table-column prop="ctaxainvname" label="物料描述" width="140"></el-table-column>
        <el-table-column prop="iquantityxq" label="数量" width="110"></el-table-column>
        <el-table-column prop="ipricexq" label="含税单价" width="90"></el-table-column>
        <el-table-column prop="imoneyxq" label="含税金额" width="100"></el-table-column>
        <el-table-column prop="itaxratexq" label="税率" width="60"></el-table-column>
        <el-table-column prop="inomoneyxq" label="不含税金额" width="100"></el-table-column>
        <el-table-column prop="imoneyxq" label="税额" width="110"></el-table-column>

      </el-table>
      <div slot="footer" class="dialog-footer">
        <!-- <el-button @click="closesad()">取 消</el-button>
        <el-button type="success" @click="confirm()">确 定</el-button> -->
      </div>
    </el-dialog>
    
    <el-dialog :visible.sync="summaryVisible" :append-to-body="true" customClass="assoformwarp">
      <el-table :data="invioceSummary" style="width: 100%" class="tableinput tablecenter" max-height="420" border
        :header-cell-style="{ background: '#eef1f6'}" :cell-style="{ padding: '7px 0'}">
        <el-table-column prop="cinvcode" label="物料编码" width="110"></el-table-column>
        <el-table-column prop="cinvname" label="物料描述" width="200"></el-table-column>
        <el-table-column prop="ctaxationcode" label="税收分类编码" min-width="100"></el-table-column>
        <el-table-column prop="ctaxationname" label="厂商物料名称" width="200"></el-table-column>
        <el-table-column prop="iquantity" label="数量" width="90"></el-table-column>
        <el-table-column prop="ijfmoney" label="奖罚金额" width="100"></el-table-column>
        <el-table-column prop="iallmoney" label="含税金额" width="110"></el-table-column>
        <el-table-column prop="izlkk" label="其他综合扣款" width="110"></el-table-column>
        <el-table-column prop="ikpmoney" label="开票金额" width="110"></el-table-column>

      </el-table>
      <div slot="footer" class="dialog-footer">
        <!-- <el-button @click="closesad()">取 消</el-button>
        <el-button type="success" @click="confirm()">确 定</el-button> -->
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import operprint from "../../Operation_SHOrder/Operation/Operatiopint";
  import { printExcel } from "../../../../utils/config";
  import { GetFileType } from "../../../../api/home";
  
  export default {
    components: { operprint },
    data() {
      return {
        // 当前日期
        nowdate: "",
        // 弹出框的日期
        timeval: [],
        tableorder: [],
        // 公司名称
        selectlist: [],
        tableRadio: {
          cpasturecode: "",
          copcode: "",
          cztermname: "",
          cvouchtype: "",
          cvouchtype: "",
          cpbvmemo: "",
          creceipttype: "蓝字发票",
          izlkk: '0',
        },
        qualiform: { cinvname: "", startDate: "", endDate: "", cordercode: "" },
        dialogFormVisible: false,
        orderlist: [],
        // 临时存储
        temp: [],
        // 临时存储
        tableordertemp: [],
        prinpageif: false,
        prinpagesrc: "",
        invoiceVisible: false,
        invioceform: {
          cbillname: "",
          cbillurl: "",
        },
        fileListFail: [],
        tableinvioce: [],
        tablePDF: [],
        inviocerules: {
          cbillurl: [{ required: true, message: "请上传文件", trigger: "blur" }],
        },
        tablerow: {},
        typeaccept: "",
        Cname: "",
        selectitax: [],
        inviocetemp: [],
        renyuanlist: [],
        loading: false,
        copcode: "",
        informdata: {},
        previnformdata: {},
        fullscreenLoading: false,
        dialogqueryVisible: false,
        querytableorder: [],
        loadingSC: false,
        invioceSummary: [],
        summaryVisible: false,
      };
    },
    created() {
      var myDate = new Date();
      this.nowdate =
        myDate.getFullYear() +
        "-" +
        (myDate.getMonth() + 1) +
        "-" +
        myDate.getDate();
      if (this.$route.params.tableRadio) {
        this.tableRadio = this.$route.params.tableRadio;
        this.selectlist = this.$route.params.selectlist;
        sessionStorage.setItem("params", JSON.stringify(this.$route.params));
        this.previnformdata = this.$route.params.informdata;
        sessionStorage.setItem(
          "informdata",
          JSON.stringify(this.$route.params.informdata)
        );
      } else {
        var params = JSON.parse(sessionStorage.getItem("params"));
        this.tableRadio = params.tableRadio;
        this.selectlist = params.selectlist;
        this.previnformdata = JSON.parse(sessionStorage.getItem("informdata"));
      }
      if (this.tableRadio.id != "") {
        this.GetSHDetail();
        this.GetInvoiceFile();
        this.GetInvoicMain();
      }
      console.log(this.tableRadio.iinport);
      this.FileType();
      this.GetTaxRatelList();
      this.GetInvoicePDF();
      this.tableRadio.creceipttype = "蓝字发票"
      this.tableRadio.izlkk = "0"
    },
    methods: {

      // 计算
      getitax(index) {
        this.tableorder[index].inomoney = (
          this.tableorder[index].iallmoney - this.tableorder[index].iratemoney
        ).toFixed(2);
      },
      getinomoney(index) {
        this.tableorder[index].iratemoney = (
          this.tableorder[index].iallmoney - this.tableorder[index].inomoney
        ).toFixed(2);
      },

      // 牧场人员
      GetBusinessOperList(type) {
        if (type != "2") {
          if (type == "1") {
            this.copcode = "";
            this.tableRadio.copcode = "";
            this.tableRadio.copname = "";
          }
          this.$axios({
            method: "post",
            url: "CommonModule/Op_StoreAndInvoice/GetBusinessOperList",
            data: { cztcode: this.tableRadio.cpasturecode },
          }).then((res) => {
            if (res.data.Success) {
              this.renyuanlist = res.data.Data;
            } else {
              this.$message.error(res.data.Message);
            }
          });
        } else {
          for (var i = 0; i < this.renyuanlist.length; i++) {
            if (this.renyuanlist[i].copcode == this.copcode) {
              this.tableRadio.copname = this.renyuanlist[i].copname;
              this.tableRadio.copcode = this.renyuanlist[i].copcode;
            }
          }
        }
      },
      // 合计
      getSummaries(param) {
        const { columns, data } = param;
        const sums = [];
        columns.forEach((column, index) => {
          if (index === 0) {
            sums[index] = "小计";
            return;
          }

          if (index === 9 || index === 10 || index === 11 || index === 13|| index === 14|| index === 15|| index === 16|| index === 17) {
            const values = data.map((item) => Number(item[column.property]));
            if (!values.every((value) => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => {
                const value = Number(curr);
                prev = Number(prev);
                if (!isNaN(value)) {
                  // console.log(prev + curr);
                  var prevcurr = prev + curr;
                  return prevcurr.toFixed(2);
                } else {
                  return prev.toFixed(2);
                }
              }, 0);
              sums[index] += "";
            } else {
              sums[index] = "";
            }
          } else {
            sums[index] = "";
          }
        });

        return sums;
      },
      // 税率
      GetTaxRatelList() {
        this.$axios({
          method: "post",
          url: "CommonModule/Op_Supplier/GetTaxRatelList",
        }).then((res) => {
          console.log(res, "税率");
          if (res.data.Success) {
            this.selectitax = res.data.Data;
          } else {
            this.$message.error(res.data.Message);
          }
        });
      },
      // 获取文件类型
      FileType() {
        GetFileType({ type: "03" }).then((res) => {
          console.log(res);
          if (res.data.Success) {
            this.typeaccept = res.data.Data[0].cfileformat;
          }
        });
      },
      // 保存发票
      inviocecofrim(invioceform) {
        // this.tableinvioce.forEach((row) => {
        //   if (row.cbillcode == this.invioceform.cbillcode) {
        //     this.$message.error("该发票已上传，请重新输入发票号");
        //     throw console.info("该发票已上传，请重新输入发票号");
        //   }
        // });
        // 
        this.loadingSC = true;
        this.$axios({
          method: "post",
          url: "CommonModule/Op_StoreAndInvoice/InvoicePushFeeControl",
          // data:{filePath:"/Content/CusPaperUp/1735625764267162107.png",copcode: this.tableRadio.copcode,keyid:this.tableRadio.id}
          data: { filePath: this.invioceform.cbillurl, copcode: this.tableRadio.copcode, keyid: this.tableRadio.id },
        }).then((res) => {
          console.log(res, "InvoicePushFeeControlInvoicePushFeeControlInvoicePushFeeControl");
          this.loadingSC = false;
          if (res.data.Success) {
            // this.invioceform.cbillurl="/Content/CusPaperUp/1735625764267162107.png"
            this.invioceform.cannulid = res.data.Data.invoiceMain.cannulid
            this.invioceform.cannulname = res.data.Data.invoiceMain.cannulname
            this.invioceform.cbillcode = res.data.Data.invoiceMain.cbillcode
            this.invioceform.cbuyerid = res.data.Data.invoiceMain.cbuyerid
            this.invioceform.cbuyername = res.data.Data.invoiceMain.cbuyername
            this.invioceform.dbilldate = res.data.Data.invoiceMain.dbilldate
            this.invioceform.ibillamount = res.data.Data.invoiceMain.ibillamount
            this.invioceform.inotax = res.data.Data.invoiceMain.inotax
            this.invioceform.iocr = res.data.Data.invoiceMain.iocr
            this.invioceform.itax = res.data.Data.invoiceMain.itax
            this.$refs[invioceform].validate((valid) => {
              if (valid) {
                this.tableinvioce.push(this.invioceform);
                this.closesad();
              } else {
                return false;
              }
            });
          } else {
            this.$message.error(res.data.Message);
            this.$refs[invioceform].validate((valid) => {
              if (valid) {
                this.tableinvioce.push(this.invioceform);

                this.closesad();
              } else {
                return false;
              }
            });
          }
        });

      },
      //上传文件
      handleChangeFail(file, fileList) {
        if (this.tableRadio.id == "") {
          this.$message.error("请先保存，再上传文件！");
        } else {
          this.$refs.uploadFail.submit();
        }
      },
      // 上传文件
      brforeUploadreFail(file) {
        this.loading = true;
        this.$axios({
          method: "post",
          url: "CommonModule/Op_Supplier/SupplierCheckAll",
          data: { cbilltype: "发票单上传", cbillid: this.tableRadio.id },
        })
          .then((res) => {
            console.log(res, "上传结果上传结果上传结果上传结果");

            if (res.data.Success) {
              console.log(file, '附件')
              let varparams = new FormData();
              varparams.append("file", file);
              varparams.append("file", URL.createObjectURL(file));
              varparams.append("cvoucherno", "op_invocieentryb");
              varparams.append("ctype", "03");
              varparams.append("cvoucherid", this.tableRadio.id);
              console.log(varparams, '附件')
              this.$axios({
                method: "post",
                url: "CommonModule/Op_Supplier/BaseUploadFile",
                headers: { "Content-Type": "multipart/form-data" },
                data: varparams,
                timeout: 30000000,
              }).then((res) => {
                console.log(res, "上传结果");
                this.loading = false;
                if (res.data.Success) {
                  this.$message({
                    howClose: true,
                    message: "上传成功",
                    type: "success",
                  });

                  this.invioceform.cbillurl = res.data.Data.Path;
                  this.Cname = res.data.Data.Cname;
                  this.invioceform.cbillname = res.data.Data.Cname;
                  var Path = res.data.Data.Path
                  var suffix = Path.substring(Path.lastIndexOf("."));
                  console.log(suffix); // 输出: .txt
                  if (suffix == '.pdf' || suffix == '.PDF') {
                    this.tablePDF.push({
                      cpdfurl: res.data.Data.Path,
                      cpdfname: res.data.Data.Cname,
                    });
                  }
                  console.log(this.tablePDF, '-----111------1----')
                } else {
                  this.$message.error(res.data.Message);
                }
              }).catch(function (error) {
                console.log(error);
                this.loading = false;
              });
              return false; //屏蔽了action的默认上传
            } else {
              this.$message.error(res.data.Message);
            }
          })
          .catch(function (error) {
            console.log(error);
          });
      },
      //上传文件
      handleChange(file, fileList) {
        if (this.tableRadio.id == "") {
          this.$message.error("请先保存，再上传文件！");
          throw "请先保存，再上传文件！";
        } else {
          this.$refs.uploadref.submit();
        }
      },
      // 上传文件
      brforeUploadreImportFail(file) {
        if (this.tableRadio.id == "") {
          this.$message.error("请先保存，再上传文件！");
          return;
        } else {
          this.$axios({
            method: "post",
            url: "CommonModule/Op_Supplier/SupplierCheckAll",
            data: { cbilltype: "发票单上传", cbillid: this.tableRadio.id },
          })
            .then((res) => {
              console.log(res, "上传结果上传结果上传结果上传结果");

              if (res.data.Success) {
                let varparams = new FormData();
                varparams.append("file", file);
                varparams.append("file", URL.createObjectURL(file));
                varparams.append("cvoucherno", "op_invocieentryb");
                varparams.append("ctype", "09");
                varparams.append("cvoucherid", this.tableRadio.id);
                this.$axios({
                  method: "post",
                  url: "CommonModule/Op_Supplier/BaseUploadFile",
                  headers: { "Content-Type": "multipart/form-data" },
                  data: varparams,
                  timeout: 30000000,
                }).then((res) => {
                  console.log(res, "上传结果");
                  if (res.data.Success) {
                    this.$message({
                      howClose: true,
                      message: "上传成功",
                      type: "success",
                    });
                    this.tablePDF.push({
                      cpdfurl: res.data.Data.Path,
                      cpdfname: res.data.Data.Cname,
                    });
                  } else {
                    this.$message.error(res.data.Message);
                  }
                });

                return false; //屏蔽了action的默认上传
              } else {
                this.$message.error(res.data.Message);
              }
            })
            .catch(function (error) {
              console.log(error);
            });
        }
      },
      // 上传发票单
      myinvoice() {
        if (this.tableRadio.id == "") {
          this.$message.error("请先保存，再上传文件！");
          return;
        }
        this.invoiceVisible = true;
        this.invioceform = {
          cbillurl: "",
        };
        this.Cname = "";
      },
      // 获取开票汇总
      queryInvoiceSummary() {
        if (this.tableorder.length == 0) {
          this.$message.error("请先选择发票后查看汇总");
          return;
        } else {
          var arr = this.tableorder;
          var summarr = [];
          arr.map(mapItem => {
            console.log(mapItem, 'mapItem')
            if (summarr.length == 0) {
              summarr.push({
                ctaxationcode: mapItem.ctaxationcode,
                ctaxationname: mapItem.ctaxationname,
                cinvcode: mapItem.cinvcode,
                cinvname: mapItem.cinvname,
                iquantity: mapItem.iquantity,
                iallmoney: mapItem.iallmoney,
                ijfmoney: mapItem.ijfmoney,
                izlkk: mapItem.izlkk,
                ikpmoney: mapItem.ikpmoney
              })
            } else {
              let res = summarr.some(item => {
                console.log(item, 'item')
                if (item.ctaxationcode == mapItem.ctaxationcode && item.cinvcode == mapItem.cinvcode) {
                  var mapTemp = {
                    ctaxationcode: item.ctaxationcode,
                    ctaxationname: item.ctaxationname,
                    cinvcode: item.cinvcode,
                    cinvname: item.cinvname,
                    iquantity: Number(Number(item.iquantity).toFixed(2)) + Number(Number(mapItem.iquantity).toFixed(2)),
                    iallmoney: Number(Number(item.iallmoney).toFixed(2)) + Number(Number(mapItem.iallmoney).toFixed(2)),
                    ijfmoney: Number(Number(item.ijfmoney).toFixed(2)) + Number(Number(mapItem.ijfmoney).toFixed(2)),
                    izlkk: Number(Number(item.izlkk).toFixed(2)) + Number(Number(mapItem.izlkk).toFixed(2)),
                    ikpmoney: Number(Number(Number(Number(item.ikpmoney).toFixed(2))+ Number(Number(mapItem.ikpmoney).toFixed(2))).toFixed(2))
                  };
                  let index = summarr.indexOf(item);
                  // console.log(index,'index')
                  if (index > -1) {
                    // console.log('splice')
                    summarr.splice(index, 1);
                  }
                  summarr.push(mapTemp);
                  return true;
                }
              })
              
              if (!res) {
                summarr.push({
                  ctaxationcode: mapItem.ctaxationcode,
                  ctaxationname: mapItem.ctaxationname,
                  cinvcode: mapItem.cinvcode,
                  cinvname: mapItem.cinvname,
                  iquantity: mapItem.iquantity,
                  iallmoney: mapItem.iallmoney,
                  ijfmoney: mapItem.ijfmoney,
                  izlkk: mapItem.izlkk,
                  ikpmoney: mapItem.ikpmoney
                })
              }
            }
            console.log(summarr, 'summarr')
          })
          
          this.invioceSummary = summarr;
          console.log(this.invioceSummary, "this.invioceSummary")
          this.summaryVisible = true;
        }
      },
      // 获取发票详情
      queryinvoice() {
        if (this.tableinvioce.length == 0) {
          this.$message.error("请先上传发票，再查看详情！");
          return;
        } else {

          this.$axios({
            method: "post",
            url: "CommonModule/Op_StoreAndInvoice/GetInvoiceParticulars",
            data: { KeyValue: this.tableRadio.id },
          }).then((res) => {
            console.log(res, "GetInvoiceParticularsGetInvoiceParticulars");
            if (res.data.Success) {
              this.querytableorder = res.data.Data;
              this.dialogqueryVisible = true

            } else {
              this.$message.error(res.data.Message);
            }
          });
        }
      },
      GetInvoicMain() {
        this.$axios({
          method: "post",
          url: "CommonModule/Op_StoreAndInvoice/GetInvoicMain",
          data: { KeyValue: this.tableRadio.id },
        }).then((res) => {
          console.log(res, "GetInvoicMainGetInvoicMainGetInvoicMain");
          if (res.data.Success) {
            this.tableRadio = res.data.Data[0];
            this.copcode = this.tableRadio.copcode;
            this.GetBusinessOperList("0");
            if (this.tableRadio.cexch_name == "") {
              this.tableRadio.cexch_name = "人民币";
            }
          } else {
            this.$message.error(res.data.Message);
          }
        });
      },
      // 获取发票单
      GetInvoiceFile() {
        this.$axios({
          method: "post",
          url: "CommonModule/Op_StoreAndInvoice/GetInvoiceFile",
          data: { KeyValue: this.tableRadio.id },
        }).then((res) => {
          console.log(
            res,
            "GetInvoiceFileGetInvoiceFileGetInvoiceFileGetInvoiceFile"
          );
          if (res.data.Success) {
            this.inviocetemp = JSON.parse(JSON.stringify(res.data.Data));
            this.tableinvioce = res.data.Data;
          } else {
            this.$message.error(res.data.Message);
          }
        });
      },
      // 获取基本信息
      GetSHDetail() {
        this.$axios({
          method: "post",
          url: "CommonModule/Op_StoreAndInvoice/GetInvoiceDetail",
          data: { KeyValue: this.tableRadio.id },
        }).then((res) => {
          console.log(res);
          if (res.data.Success) {
            this.tableorder = res.data.Data;
            this.temp = res.data.Data;
          } else {
            this.$message.error(res.data.Message);
          }
        });
      },
      // table tr 选中触发事件
      handleRowClick(row) {
        this.$refs.multipleTable.toggleRowSelection(row);
      },
      // table 选择
      handleSelectionChange(val) {
        this.temp = val;
        console.log(val);
      },
      // 我的订货单
      myorder() {
        if (this.tableRadio.cpasturecode != "") {
          this.GetRKList();
          this.dialogFormVisible = true;
        } else {
          this.$message.error("请选择公司！");
        }
      },
      // 关闭
      closesad() {
        this.temp = [];
        this.dialogFormVisible = false;
        this.loading = false;
        // this.invioceform = {
        //   cbillcode: "",
        //   ibillamount: "",
        //   itax: "",
        //   inotax: "",
        //   cisupload: "",
        //   cbillurl: "",
        //   cinvoicecode: "",
        //   dbilldate: "",
        //   iprice_file: "",
        //   itaxrate: "",
        // };
        this.invioceform = {
          cbillurl: "",
        };
        this.Cname = "";
        this.invoiceVisible = false;
      },
      // 提示框确认
      confirm() {
        this.tableordertemp = [];
        this.tableordertemp = this.temp;
        console.log(this.temp);
        var arr = [];
        for (var a = 0; a < this.temp.length; a++) {
          if (this.temp[a].itzprice == "") {
            this.temp[a].itzprice = 0;
          }
          if (this.temp[a].iprice == "") {
            this.temp[a].iprice = 0;
          }
          if (this.temp[a].itoltalmoney == "") {
            this.temp[a].itoltalmoney = 0;
          }
          if (this.temp[a].imoney == "") {
            this.temp[a].imoney = 0;
          }
          if (this.temp[a].iquantity == "") {
            this.temp[a].iquantity = 0;
          }
          if (this.temp[a].irate == "") {
            this.temp[a].irate = 0;
          }
          if (this.temp[a].iratemoney == "") {
            this.temp[a].iratemoney = 0;
          }
          if (this.temp[a].irateprice == "") {
            this.temp[a].irateprice = 0;
          }
          if (this.temp[a].irkqty == "") {
            this.temp[a].irkqty = 0;
          }
          if (this.temp[a].ijfmoney == "") {
            this.temp[a].ijfmoney = 0;
          }
          if (this.temp[a].inotaxeprice == "") {
            this.temp[a].inotaxeprice = 0;
          }
          if (this.temp[a].itaxe == "") {
            this.temp[a].itaxe = 0;
          }
          if (this.temp[a].ipriceunit == "") {
            this.temp[a].ipriceunit = 0;
          }
          if (this.temp[a].ikpmoney == "") {
            this.temp[a].ikpmoney = 0;
          }
          arr.push({
            cincode: this.temp[a].crkcode,
            cinvcode: this.temp[a].csapinvcode,
            cinvname: this.temp[a].cinvname,
            cinvstd: this.temp[a].cinvmodel,
            cinvunit: this.temp[a].cunit,
            cpocode: this.temp[a].cordercode,
            cyear: this.temp[a].cyear,
            drkdate: this.temp[a].drkdate,
            iallmoney: this.temp[a].itoltalmoney.toFixed(2),
            imoney: this.temp[a].imoney,
            iprice: this.temp[a].iprice.toFixed(4),
            iquantity: this.temp[a].inumber,
            ikpmoney: this.temp[a].ikpmoney,
            irate: this.temp[a].itaxe.toFixed(2),
            iratemoney: this.temp[a].itaxmoney.toFixed(2),
            irateprice: this.temp[a].iprice.toFixed(2),
            irkqty: this.temp[a].inumber,
            ctaxationname: this.temp[a].ctaxationname,
            ctaxationcode: this.temp[a].ctaxationcode,
            csapposid: this.temp[a].corderhang,
            csaprdsid: this.temp[a].crkhang,
            csapid: this.temp[a].id,
            cpersoncode: this.temp[a].cpersoncode,
            cpinpai: this.temp[a].cpinpai,
            cremark: this.temp[a].cremark,
            itzprice: this.temp[a].itzprice,
            cckhang: this.temp[a].cckhang,
            cckpzcode: this.temp[a].cckpzcode,
            cckhang: "",
            cckpzcode: "",
            ijfmoney: this.temp[a].ijfmoney,
            inomoney: this.temp[a].inomoney.toFixed(2),
            ipriceunit: this.temp[a].ipriceunit,
            izlkk: this.temp[a].izlkk,
            cdkpid: this.temp[a].cdkpid,
          });
          console.log(this.temp[a].inotaxeprice);
        }
        console.log(arr, "3333333332");
        console.log(this.tableorder, "1111");
        arr = this.tableorder.concat(arr);

        this.tableorder = this.unique(arr);
        setTimeout(() => {
          this.dialogFormVisible = false;
        }, 60);
        var arrkk = 0
        for (let i = 0; i < this.tableorder.length; i++) {
          const element = this.tableorder[i];
          arrkk = arrkk + element.izlkk
        }
        this.tableRadio.izlkk = Number(arrkk).toFixed(2)
        console.log(this.tableorder, "1111");
      },
      unique(arr) {
        // 根据唯一标识orderId来对数组进行过滤
        const res = new Map(); //定义常量 res,值为一个Map对象实例 //返回arr数组过滤后的结果，结果为一个数组   过滤条件是，如果res中没有某个键，就设置这个键的值为1
        return arr.filter(
          (arr) => !res.has(arr.csapid) && res.set(arr.csapid, 1)
        );
      },
      // 返回
      returnpage() {
        sessionStorage.removeItem("params");
        this.$router.push({
          path: "/InvoiceNotice/InvoiceNotice",
          query: { informdata: this.previnformdata },
        });
      },
      //  获取订单列表
      GetRKList() {
        this.$axios({
          method: "post",
          url: "CommonModule/Op_StoreAndInvoice/GetRKList",
          data: {
            // starttime: this.qualiform.startDate,
            // endtime: this.qualiform.endDate,
            cinvname: this.qualiform.cinvname,
            cztcode: this.tableRadio.cpasturecode,
            cordercode: this.qualiform.cordercode,
          },
        }).then((res) => {
          console.log(res);
          if (res.data.Success) {
            this.orderlist = res.data.Data;
            this.toggleSelection(this.tableordertemp);
          } else {
            this.$message.error(res.data.Message);
          }
        });
      },
      onSubmit() {
        console.log("submit!");
      },
      // 删除
      del(row, i) {
        this.tableorder.splice(i, 1);
        // this.tableordertemp.op_purchaseorder_list_autoid==row.clistautoid
        for (var a; a < this.tableordertemp.length; a++) {
          if (
            this.tableordertemp[a].op_purchaseorder_list_autoid == row.clistautoid
          ) {
            this.tableordertemp.splice(a, 1);
          }
        }
        var arrkk = 0
        for (let i = 0; i < this.tableorder.length; i++) {
          const element = this.tableorder[i];
          arrkk = arrkk + element.izlkk
        }
        this.tableRadio.izlkk = Number(arrkk).toFixed(2)
      },
      //手工上传
      FeeControl(row, i) {
        if (row.cbillcode == "") {
          this.$message.error("请输入发票号");
          return
        }
        // if (row.cinvoicecode == "") {
        //   this.$message.error("请输入发票代码");
        //   return
        // }
        if (row.dbilldate == "") {
          this.$message.error("请输入开票日期");
          return
        }
        if (row.inotax == "") {
          this.$message.error("请输入不含税金额");
          return
        }
        if (this.tableRadio.copcode == "") {
          this.$message.error("请选择牧场人员");
          return
        }
        if (this.tableRadio.cpasturecode == "") {
          this.$message.error("请选择公司名称");
          return
        }
        var cptable = {
          ccorpcode: this.tableRadio.cpasturecode
        }
        var srjson = { ...row, ...this.tableRadio, ...cptable }
        var dataform = {
          strJson: JSON.stringify(srjson),
          type: "srm_supplier_pc",
          KeyValue: this.tableRadio.id
        }
        this.$axios({
          method: "post",
          url: "CommonModule/Op_StoreAndInvoice/InvoiceManualPushFeeControl",
          data: dataform,
        }).then((res) => {
          console.log(res);
          if (res.data.Success) {
            this.$message.success(res.data.Message);
            this.tableinvioce[i].cannulid = res.data.Data.invoiceMain.cannulid
            this.tableinvioce[i].cannulname = res.data.Data.invoiceMain.cannulname
            this.tableinvioce[i].cbillcode = res.data.Data.invoiceMain.cbillcode
            this.tableinvioce[i].cbuyername = res.data.Data.invoiceMain.cbuyername
            this.tableinvioce[i].cinvoicecode = res.data.Data.invoiceMain.cinvoicecode
            // this.tableinvioce[i].dbilldate=res.data.Data.invoiceMain.dbilldate
            this.tableinvioce[i].ibillamount = res.data.Data.invoiceMain.ibillamount
            this.tableinvioce[i].inotax = res.data.Data.invoiceMain.inotax
            this.tableinvioce[i].iocr = res.data.Data.invoiceMain.iocr
            this.tableinvioce[i].itax = res.data.Data.invoiceMain.itax
            this.querytableorder = this.querytableorder.concat(res.data.Data.invoiceInfo)
          } else {
            this.$message.error(res.data.Message);
          }
        });
      },
      // 删除
      delinvioce(row, i) {
        console.log(row, "dashed")
        console.log(row.cbillurl, "cbillurl")
        if (row.op_vendor_vouchfile_autoid == undefined || row.op_vendor_vouchfile_autoid == "") {
          var jsondetail = JSON.parse(JSON.stringify(this.querytableorder))
          for (let index = 0; index < jsondetail.length; index++) {
            const element = jsondetail[index];
            if (element.cfpcodexq == row.cbillcode) {
              this.querytableorder.splice(index, 1)
            }
          }
          var pdfJsonFile = JSON.parse(JSON.stringify(this.tablePDF))
          for (let index = 0; index < pdfJsonFile.length; index++) {
            const element = pdfJsonFile[index];
            if (element.cpdfurl == row.cbillurl) {
              this.tablePDF.splice(index, 1)
            }
          }
          setTimeout(() => {
            this.tableinvioce.splice(i, 1);
            this.inviocetemp.splice(i, 1);
          }, 500);
        } else {
          this.$axios({
            method: "post",
            url: "CommonModule/Op_StoreAndInvoice/DeleteInvoiceItem",
            data: { keyId: this.tableRadio.id, cbillurl:row.cbillurl },
          }).then((res) => {
            console.log(
              res,
              "DeleteInvoiceItemDeleteInvoiceItemDeleteInvoiceItem"
            );
            if (res.data.Success) {
              this.GetInvoiceFile();
              this.GetInvoicePDF();
              this.$message.error(res.data.Message);
            } else {
              this.$message.error(res.data.Message);
            }
          });
        }
      },
      delinfile(row, i) {
        this.tablePDF.splice(i, 1);
      },
      // 查询是否选中
      toggleSelection(rows) {
        var that = this;
        rows = JSON.parse(JSON.stringify(rows));
        that.$nextTick(() => {
          if (that.$refs.multipleTable) {
            that.$refs.multipleTable.clearSelection();
          }
          var arr = this.orderlist;
          rows.forEach((row) => {
            for (let j in arr) {
              if (row.id == arr[j].id) {
                // console.log(row)
                that.$refs.multipleTable.toggleRowSelection(arr[j], true);
                break;
              }
            }
          });
        });
      },
      //验证
      svevivade(type) {
        // this.inviocetemp.forEach((temp, index) => {
        //   if (
        //     Math.floor(temp.itax) != Math.floor(this.tableinvioce[index].itax)
        //   ) {
        //     this.$message.error("税额只能进行小数位的调整！");
        //     throw "税额只能进行小数位的调整！";
        //   }
        //   if (
        //     Math.floor(temp.inotax) != Math.floor(this.tableinvioce[index].inotax)
        //   ) {
        //     this.$message.error("不含税金额只能进行小数位的调整！");
        //     throw "不含税金额只能进行小数位的调整！";
        //   }
        // });

        if (this.tableRadio.copcode == "") {
          this.$message.error("请选择牧场人员！");

          throw "请选择牧场人员";
        }
        console.log(this.tableRadio);
        if (this.tableRadio.cvouchtype == "") {
          this.$message.error("请选择发票类型！");

          throw "请选择发票类型";
        }
        if (this.tableRadio.ccorpcode != "") {
          for (var a = 0; a < this.selectlist.length; a++) {
            if (this.selectlist[a].ccorpcode == this.tableRadio.cpasturecode) {
              this.tableRadio.cpasturename = this.selectlist[a].ccorpname;
            }
          }
        }
        var KeyValue;
        if (this.tableRadio.id) {
          KeyValue = this.tableRadio.id;
        } else {
          KeyValue = "";
        }
        if (this.tableorder.length != 0) {
          // this.tableorder.forEach((temp, index) => {
          //   if (
          //     Math.floor(temp.iratemoney) == 0 &&
          //     Math.floor(temp.iratemoney) == ""
          //   ) {
          //     this.$message.error("发票录入中的税额不能为0！");
          //     throw "发票录入中的税额不能为0！";
          //   }
          // });
          if (type == "1") {
            this.$axios({
              method: "post",
              url: "CommonModule/Op_StoreAndInvoice/GetInvoiceParticulars",
              data: { KeyValue: this.tableRadio.id },
            }).then((res) => {
              console.log(res, "GetInvoiceParticularsGetInvoiceParticulars");
              if (res.data.Success) {
                this.querytableorder = res.data.Data;
                this.SaveSHInfo(KeyValue);

              } else {
                this.$message.error(res.data.Message);
              }
            });

          }
          if (type == "2") {
            // if (this.tableRadio.cvouchtype == "电子发票") {
            //   if (this.tablePDF.length == 0) {
            //     this.$message.error("请上传电子发票文件！");
            //     throw "请上传电子发票文件！";
            //   }
            // }
            this.SubmitInvoice(KeyValue);
          }
        } else {
          this.$message.error("请选择发票单");
        }
      },
      // 保存
      SaveSHInfo(KeyValue) {
        console.log(this.tableorder, "保存");
        this.$axios({
          method: "post",
          url: "CommonModule/Op_StoreAndInvoice/SaveInvoice",
          data: {
            KeyValue: KeyValue,
            JsonInfo: JSON.stringify(this.tableRadio),
            JsonDetail: JSON.stringify(this.tableorder),
            JsonFile: JSON.stringify(this.tableinvioce),
            JsonPDF: JSON.stringify(this.tablePDF),
            InvoiceDetails: JSON.stringify(this.querytableorder)
          },
        }).then((res) => {
          console.log(res);
          if (res.data.Success) {
            this.$message.success(res.data.Message);
            this.tableRadio.id = res.data.Data;
            this.GetSHDetail();
            this.GetInvoiceFile();
            this.GetInvoicMain();
          } else {
            this.$message.error(res.data.Message);
          }
        });
      },
      // 提交
      SubmitInvoice() {
        console.log(this.tableRadio);

        this.$confirm(
          "请确认是否保存数据，如有修改请先保存再提交，提交之后将无法修改，请确认是否操作！！",
          "提示",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          }
        )
          .then(() => {
            var keyid;
            if (this.tableRadio.id != "" && this.tableRadio.id != undefined) {
              keyid = this.tableRadio.id;
              this.fullscreenLoading = true;
              this.$axios({
                method: "post",
                url: "CommonModule/Op_StoreAndInvoice/SubmitInvoice",
                data: { KeyValue: keyid },
              }).then((res) => {
                console.log(res);
                this.fullscreenLoading = false;
                if (res.data.Success) {
                  this.$message.success(res.data.Message);
                  this.returnpage();
                } else {
                  this.$message.error(res.data.Message);
                }
              });
            } else {
              this.$message.error("请先保存发票制作");
            }
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消提交发票",
            });
          });
      },
      // 删除
      DeleteSHInfo() {
        this.$confirm("请确认是否删除该数据！！", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            if (this.deldatakey == "") {
              this.$message.error("请先保存信息");
            } else {
              this.$axios({
                method: "post",
                url: "CommonModule/Op_StoreAndInvoice/DeleteInvoice",
                data: { KeyValue: this.tableRadio.id },
              }).then((res) => {
                console.log(res);
                if (res.data.Success) {
                  this.returnpage();
                } else {
                  this.$message.error(res.data.Message);
                }
              });
            }
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消提交发票",
            });
          });
      },
      printclose(val) {
        this.prinpageif = val;
      },
      //打印
      printpage() {
        if (this.tableorder.length != 0) {
          printExcel("export");
        } else {
          this.$message.error("暂无信息可打印");
        }
      },
      // printpage() {
      //   var id = "";
      //   if (this.tableRadio.id == undefined) {
      //     this.$message.error("暂无信息可打印！！");
      //   }
      //   if (this.tableRadio.id != "") {
      //     this.prinpagesrc =
      //       this.global.bxios_URL +
      //       "CommonModule/PrintView/SetPrintView?KeyValue=" +
      //       this.tableRadio.id;
      //     this.prinpageif = true;
      //   } else {
      //     this.$message.error("请选中要打印的数据！！");
      //   }
      // },

      //撤销提交
      UnSubmitInvoice() {
        this.$axios({
          method: "post",
          url: "CommonModule/Op_StoreAndInvoice/UnSubmitInvoice",
          data: { KeyValue: this.tableRadio.id },
        }).then((res) => {
          console.log(res);
          if (res.data.Success) {
            this.$message.success(res.data.Message);
            this.returnpage();
          } else {
            this.$message.error(res.data.Message);
          }
        });
      },
      clickChange(item) {
        this.tablerow = item;
        console.log(this.tablerow);
      },
      GetHTFileUrl() {
        if (this.tablerow.cbillurl != "" && this.tablerow.cbillurl != undefined) {
          window.open(this.global.BASE_URL + this.tablerow.cbillurl);
        } else {
          this.$message.error("暂无文件！！");
        }
      },
      getyulan(row, index) {
        if (row.cpdfurl != "" && row.cpdfurl != undefined) {
          window.open(this.global.BASE_URL + row.cpdfurl);
        } else {
          this.$message.error("暂无文件！！");
        }
      },
      GetInvoicePDF() {
        this.$axios({
          method: "post",
          url: "CommonModule/Op_StoreAndInvoice/GetInvoicePDF",
          data: { KeyValue: this.tableRadio.id },
        }).then((res) => {
          console.log(res, "GetInvoicePDF");
          if (res.data.Success) {
            this.tablePDF = res.data.Data;
          } else {
            this.$message.error(res.data.Message);
          }
        });
      },
      handleExport (type) { /** 导出按钮操作 */
        console.log(this.tableRadio.id)
        if (this.tableRadio.id == "") {
          this.$message.error("请先保存！");
          return;
        }
        var date=this.parseTime(new Date())
        console.log(date)
        var dataform={
          type:type,
          keyid:this.tableRadio.id
        }
        this.$axios({
        method: "post",
        url: "/CommonModule/Op_Supplier/SupplierExportExcelPC",
        data: dataform,
      }).then((res) => {
        console.log(res);
        if(res.data.Success){
          this.down(res.data.Data,res.data.Message)
        } else {
          this.$message.error(res.data.Message);
        }
      });
      },
      // 下载
      down (url,title) {
        if (url != "") {
          // 根据浏览地址下载文件;
          const a = document.createElement("a");
          let urlblob = this.global.bxiosdow + url;
          // console.log(urlblob);
          // window.open(urlblob);
          fetch(urlblob)
            .then((res) => res.blob())
            .then((blob) => {
              // 将链接地址字符内容转变成blob地址
              a.href = URL.createObjectURL(blob);
              console.log(a.href);
              a.download = title; // 下载文件的名字
              document.body.appendChild(a);
              a.click();
            });
        } else {
          this.$message.error("暂无文件");
        }
      }
    },
  };
</script>

<style scoped>
  .itemwidth .el-input {
    width: 160px;
  }

  .itemwidth .el-select {
    width: 160px;
  }

  .el-form-item {
    margin-bottom: 10px;
  }

  .cremark .el-input {
    width: 420px;
  }
</style>